import type { ButtonHTMLAttributes, ReactNode, Ref } from "react";
import { styled } from "@pigment-css/react";

const Button = styled("button")(({ theme }) => ({
  width: theme.fieldSalesTwo.spacing[20],
  height: theme.fieldSalesTwo.spacing[20],
  padding: theme.fieldSalesTwo.spacing[14],
  "& svg": {
    flexShrink: 0,
    height: "1rem",
    width: "1rem",
  },
  margin: 0,
  border: "none",
  background: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  color: "inherit",
  borderRadius: theme.fieldSalesTwo.radius.circular,
  transition: "background-color 120ms ease, box-shadow 120ms ease, transform 120ms ease, opacity 120ms ease",
  "&:hover": {
    backgroundColor: theme.fieldSalesTwo.colors.neutral[200],
    boxShadow: `inset 0 ${theme.strokeWidth.regular} 0 ${theme.fieldSalesTwo.colors.surface.glassBorder}`,
  },
  "&:active": {
    backgroundColor: theme.fieldSalesTwo.colors.neutral[300],
    boxShadow: `inset 0 ${theme.strokeWidth.regular} 0 ${theme.fieldSalesTwo.colors.surface.glassBorder}`,
    transform: "scale(0.92)",
  },
  "&:focus-visible": {
    outline: `${theme.strokeWidth.regular} solid ${theme.fieldSalesTwo.colors.neutral[700]}`,
    outlineOffset: theme.fieldSalesTwo.spacing[2],
  },
  "&:disabled": {
    cursor: "not-allowed",
    opacity: 0.4,
  },
}));

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  "aria-label": string;
  children: ReactNode;
  ref?: Ref<HTMLButtonElement>;
}

export function IconButton({ children, type = "button", ref, ...rest }: IconButtonProps) {
  return (
    <Button type={type} ref={ref} {...rest}>
      {children}
    </Button>
  );
}
